import { menuItemsDTO } from "./SidebarContentV2";

export default function SideBarDummyContent() : menuItemsDTO[] {
    return [
        {
            title: "Κεντρική",
            icon: "Home",
            path: "/"          
        },
        {
            title: "Κινήσεις Χρηστών",
            icon: "User",
            path: "/userinspector"          
        },
       /*  {
            title: "Χρεώσεις τηλεφωνίας",          
            submenu: [
                {
                    title: "-",
                    path: "-",
                }
            ]
        }, */
        {
            title: "Διαχείριση",          
            submenu: [
                {
                    title: "Διαχείριση Γραμμών",
                    path: "/phone-charges/phone-lines",
                    icon: "Phone",
                },
                {
                    title: "Διαχείριση Μονάδων",
                    path: "/configuration/unitconfiguration/establishments",
                    icon: "Home",
                },
                {
                    title: "Παράμετροι",
                    path: "/configuration/parameters/geographicals",
                    icon: "Settings",
                },
                /* {
                    title: "Τηλεφωνικά Κέντρα",
                    path: "/configuration/phonecenters",
                    icon: "Phone"
                } */
            ]
        },
        {
            title: "Χρεώσεις",
            submenu:[
                {   
                    title: "Φόρτωση αρχείου",
                    icon: "File",
                    path: "/billing/file-upload" 
                },
                {   
                    title: "Συγκεντρωτική Οθόνη",
                    icon: "CoinsStacked",
                    path: "/billing/summary" 
                }
            ]
                    
        },
        {
            title: "Άλλα",
            submenu:[
                {   
                    title: "Πληροφορίες",
                    icon: "Info",
                    path: "/about" 
                }
            ]    
        },
        
        
        
    ];

}